export default __webpack_public_path__ + "static/media/card-img.8e480075.jpg";